import { createEventFactory, createName } from '@cp/shared/tracking';

export const findHelperEvent = createEventFactory({
  name: createName('bottomMenu', 'catalog', 'click'),
  goalId: 'nazhatie_na_knopku_poisk_pomoshchnika_v_navigacii',
  goalName: 'Нажатие на кнопку "Поиск помощника" в навигации',
});

export const findJobEvent = createEventFactory({
  name: createName('bottomMenu', 'findJob', 'click'),
  goalId: 'nazhatie_na_knopku_poisk_raboty',
  goalName: 'Нажатие на кнопку "Поиск работы"',
});

export const messagesTabEvent = createEventFactory({
  goalName: 'Нажатие на значок сообщения в навигации',
  goalId: 'nazhatie_na_znachok_soobshcheniya_v_navigacii',
  name: createName('bottomMenu', 'dialog', 'click'),
});
